// Masonry Overlay Ajax Images

$.fn.initMasonryImagesSlider = function() {
    var viewport_width = $(document).width();
    if(viewport_width>768) return;

    $(".masonry-images").slick({
        dots: false,
        infinite: true,
        autoplaySpeed: 3000,
        speed: 500,
        autoplay:true,
        arrows:false,
        mobileFirst:true,
        pauseOnHover:true,
        centerMode: false,
        adaptiveHeight: false,
        focusOnSelect: false,
        variableWidth: false,
        responsive:[
            {
                breakpoint: 768,
                settings: "unslick"
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

$.fn.loadMasonryImage = function() {
    var viewport_width = $(document).width();
    //if(viewport_width<768) return;
    var pixel_ratio = window.devicePixelRatio;
    $('.masonry-item').bind('inview', function(event, visible) {
        var element = $(this);
        var image_name = $(element).data('image');
        var image_src = $(element).find('.masonry-image').attr('src');
        //var image_orginal_src = image_src.replace(/-\d+x\d+/g,'');
        var is_placeholder = image_src.indexOf("masonry-placeholder.gif");
        var element_width = $(element).width();
        var loading_complete = $(element).hasClass('loading-complete');

        if(!loading_complete && is_placeholder != -1) {

            $(element).addClass('is-loading');
            $.ajax({
                type: 'POST',
                url: js_vars.ajax_url,
                dataType: 'json',
                data: {
                    action: 'perform_section_ajax',
                    fn: 'get_image_src',
                    image: image_name,
                    viewport_width: viewport_width,
                    pixel_ratio: pixel_ratio,
                    element_width: element_width
                },
                success: function (data, textStatus, XMLHttpRequest) {
                    if(data.adaptive_url!='') {
                        $(element).find('img').attr('src',data.adaptive_url);
                    } else {
                        $(element).find('img').attr('src',data.small_url);
                    }
                    $(element).removeClass('is-loading');
                    $(element).addClass('loading-complete');
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    $(element).removeClass('is-loading');
                    $(element).addClass('error-loading');
                }
            });
        }
    });
}

$.fn.resetMasonryImage = function() {
    $(this).removeClass('loading-complete');
}

$.fn.showMasonryImageOverlay = function() {
    var viewport_width = $(document).width();
    if(viewport_width<768) return;
    $('.masonry-item').on('click',function(e){
        e.preventDefault();
        $('html').addClass('masonry-overlay-active');

        var overlay = $('.masonry-overlay-container');
        //overlay.attr('data-current-index',index);

        overlay.removeClass('loading-complete');
        overlay.addClass('is-loading');

        var image = $(this).find('.masonry-image');
        //var item = $(this).closest('.masonry-item');
        //var images = $(this).closest('.masonry-images').children();
        //var index = $(images).index(item);
        //var href = $(this).attr('href');
        var src = image.attr('src');
        var url = src.replace(/-\d+x\d+/g,'');

        $.ajax({
            type: 'GET',
            url: url,
            cache: true,
            processData : false,
            success: function (data, textStatus, XMLHttpRequest) {
                var image = "url(" + url +")";
                overlay.find('.masonry-overlay-image').css('background-image',image);
                overlay.removeClass('is-loading');
                overlay.addClass('loading-complete');
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                overlay.removeClass('is-loading');
                overlay.addClass('error-loading');
            }
        });
    });
}

/*
$.fn.showNextMasonryImageOverlay = function() {
    $('.masonry-next').on('click',function(e){
        e.preventDefault();
        var overlay = $('.masonry-overlay-container');
        var index = overlay.attr('data-current-index');
        var imageCount = $(".masonry-images>.masonry-item").length;
        if(index < imageCount-1){
            overlay.removeClass('loading-complete');
            overlay.addClass('is-loading');
            overlay.find('.masonry-overlay-image').css('background-image','');
            index++
            overlay.attr('data-current-index',index);
            var newImage = $('.masonry-image').eq(index);
            var src = $(newImage).attr('src');
            var url = src.replace(/-\d+x\d+/g,'');
            $.ajax({
                type: 'GET',
                url: url,
                cache: true,
                processData : false,
                success: function (data, textStatus, XMLHttpRequest) {
                    var image = "url(" + url +")";
                    overlay.find('.masonry-overlay-image').css('background-image',image);
                    overlay.removeClass('is-loading');
                    overlay.addClass('loading-complete');
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    overlay.removeClass('is-loading');
                    overlay.addClass('error-loading');
                }
            });
        }
    });
}

$.fn.showPrevMasonryImageOverlay = function() {
    $('.masonry-prev').on('click',function(e){
        e.preventDefault();
        var overlay = $('.masonry-overlay-container');
        var index = overlay.attr('data-current-index');
        //var imageCount = $(".masonry-images>.masonry-item").size();
        if(index > 0){
            overlay.removeClass('loading-complete');
            overlay.addClass('is-loading');
            overlay.find('.masonry-overlay-image').css('background-image','');
            index--
            overlay.attr('data-current-index',index);
            var newImage = $('.masonry-image').eq(index);
            var src = $(newImage).attr('src');
            var url = src.replace(/-\d+x\d+/g,'');
            $.ajax({
                type: 'GET',
                url: url,
                cache: true,
                processData : false,
                success: function (data, textStatus, XMLHttpRequest) {
                    var image = "url(" + src +")";
                    overlay.find('.masonry-overlay-image').css('background-image',image);
                    overlay.removeClass('is-loading');
                    overlay.addClass('loading-complete');
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    overlay.removeClass('is-loading');
                    overlay.addClass('error-loading');
                }
            });
        }
    });
}
*/

$(window).resize(function() {
    $().initMasonryImagesSlider();
    $().loadMasonryImage();
    $().showMasonryImageOverlay();
    //$().showNextMasonryImageOverlay();
    //$().showPrevMasonryImageOverlay();
});


$(document).ready(function(){

    $().initMasonryImagesSlider();
    $().loadMasonryImage();
    $().showMasonryImageOverlay();
    //$().showNextMasonryImageOverlay();
    //$().showPrevMasonryImageOverlay();

    $('.masonry-close').on('click',function(e){
        e.preventDefault();
        $('html').removeClass('masonry-overlay-active');
    });

    $(document).on('keyup',function(evt) {
        if (evt.keyCode == 27) {
            $('html').removeClass('masonry-overlay-active');
        }
    });
});
